angular.module('passbooks')

    .controller("PassbooksListCtrl", ['$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter','$state', 'logService',
        function ($rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $state, logService) {

            $rootScope.title = $filter('translate')('passbooks.title');
            logService.debug($filter('translate')('passbooks.title'));
            $rootScope.breadcrumb = [
                { title: $filter('translate')('passbooks.title') }
            ];

            $scope.allowWrite = true //LoginService.permissionExist("AUTHENTICATION_SERVICES_WRITE");

            $scope.gridOptions = {
                pdfTitle: $filter('translate')('passbooks.title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                enableSorting: true,
                paginationPageSizes: [10, 20, 30],
                paginationPageSize: 10,
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    { name: 'id', visible: true, enableHiding: false, exporterSuppressExport: true, maxWidth: 100},
                    { name: 'name', displayName: $filter('translate')('general.name'), enableFiltering: true, enableHiding: false },
                    {
                        name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                            { title: $filter('translate')('general.button_duplicate'), action: ' ng-click="grid.appScope.duplicatePassbook(row.entity.id)" ng-if="grid.appScope.allowWrite && row.entity.id != null" style="padding: 1px 0px"', cssIconClass: "fa fa-copy" },
                            { title: $filter('translate')('general.button_edit'), action: 'ui-sref="passbooks.edit({id:row.entity.id})"; ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-edit" },
                            { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                        ], { cssClass: "pull-right" })
                    },
                ],
                getData: function (options) {
                    return Restangular.all('Passbooks').getList(options)
                }
            };


            $scope.goToEdit = function (id) {
                $state.go("passbooks.edit", { id: id });
            };

            $scope.duplicatePassbook = function (id) {

                let params = { passbookId: id};
                Restangular.all('Passbooks').customPOST({}, "DuplicatePassbook", params).then(function (result) {
                    if (result.id > 0) {
                        toastr.success($filter('translate')('general.create_success'));
                        $scope.gridOptions.loadData();
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });

            }

            $scope.deleteDialog = function (id, name) {
                $scope.id = id;
                $scope.name = name;
                modalService.confirm({
                    title: $filter('translate')('passbooks.button_delete'),
                    message: $filter('translate')('passbooks.delete_message') + " " + $scope.name + "?",
                    onAccept: function () {
                        Restangular.one('Passbooks', $scope.id).remove().then(function () {
                            toastr.success($filter('translate')('passbooks.deleted_success'));
                            $scope.gridOptions.gridApi.core.raise.itemDeleted($scope);

                        }, function (response) {
                            $scope.errorMessage = response.message;
                        });
                    }
                });


            }
        }])